import { CalendarEvent } from 'owa-calendar-types';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import { isLinkedCalendar } from 'owa-calendar-properties';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';

/**
 * Gets whether the current item is on someone else's calendar
 * @param item calendar item object
 */
export default function isMeetingOnCalendarSharedWithMe(item: CalendarEvent): boolean {
    if (item) {
        const calendarEntry = getCalendarEntryByFolderId(item.ParentFolderId.Id);
        if (calendarEntry) {
            return (
                (calendarEntry as LocalCalendarEntry).IsSharedWithMe ||
                isLinkedCalendar(calendarEntry)
            );
        }
    }
    return false;
}
